import { LAYER, POPUP_IDS } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

/**
 * @param {object} action
 * @param {boolean} action.isLoginAgainPopup
 * @param {Function} [action.onAccept]
 * @param {Function} [action.onClose]
 * @param {Function} [action.onDecline]
 * @param {string} [action.className]
 */
export const showLogoutNotificationPopupAction = ({
    isLoginAgainPopup,
    onAccept = undefined,
    onClose = undefined,
    onDecline = undefined,
    className = 'logout-notification-popup'
}) =>
    isLoginAgainPopup
        ? showConfirmationPopupAction({
            onAccept,
            onDecline,
            onClose,
            className,
            id: POPUP_IDS.LOGOUT_NOTIFICATION_POPUP,
            layer: LAYER.HIGH_PRIORITY,
            isModal: false,
            title: 'playtech.mobile.system.logout.title',
            content: 'playtech.mobile.system.logout.message',
            acceptBtnText: 'playtech.mobile.system.loginagain.button.title',
            declineBtnText: 'playtech.mobile.system.ok.button.title'
        })
        : showCommonPopupAction({
            className,
            onClose,
            id: POPUP_IDS.LOGOUT_NOTIFICATION_POPUP,
            layer: LAYER.HIGH_PRIORITY,
            title: 'playtech.mobile.system.logout.title',
            content: 'playtech.mobile.system.logout.message'
        });
